import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { roleGuard } from './core/guards/role.guard';
import { AuthLayoutComponent } from './shared/layouts/auth-layout/auth-layout.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: '',
    component: AuthLayoutComponent,
    children: [
      {
        path: 'login',
        loadComponent: () =>
          import('./features/auth/login/login.component').then((m) => m.LoginComponent),
      },
      {
        path: 'forgot-password',
        loadComponent: () =>
          import('./features/auth/forgot-password/forgot-password.component').then(
            (m) => m.ForgotPasswordComponent,
          ),
      },
    ],
  },
  {
    path: 'role-select',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/auth/role-select/role-select.component').then((m) => m.RoleSelectComponent),
  },
  {
    path: 'super-admin',
    canActivate: [authGuard, roleGuard],
    data: { roles: ['SUPER_ADMIN'] },
    loadChildren: () => import('./features/super-admin/super-admin.routes'),
  },
  {
    path: 'admin',
    canActivate: [authGuard, roleGuard],
    data: { roles: ['ADMIN'] },
    loadChildren: () => import('./features/admin/admin.routes'),
  },
  {
    path: 'teacher',
    canActivate: [authGuard, roleGuard],
    data: { roles: ['TEACHER'] },
    loadChildren: () => import('./features/teacher/teacher.routes'),
  },
  {
    path: 'student',
    canActivate: [authGuard, roleGuard],
    data: { roles: ['STUDENT'] },
    loadChildren: () => import('./features/student/student.routes'),
  },
  {
    path: 'parent',
    canActivate: [authGuard, roleGuard],
    data: { roles: ['PARENT'] },
    loadChildren: () => import('./features/parent/parent.routes'),
  },
  {
    path: '**',
    redirectTo: 'login',
  },
];
